import { analyticsIdentify, analyticsTrack } from '../application/javascripts/analytics_util';
import { triggerImpactSubscriptionConversion } from '../tracking/index';
import { User } from './backend-api/currentUser';
import { SubscriptionResponse } from './backend-api/subscribe';
import { GtagEvents } from './interfaces';

const SUBSCRIPTION_CONVERSION_EVENT_NAME = 'Subscription Conversion';

// This function allows us to pass a tracking properties object like {key: value}, and it
// converts the keys to "data-key" so that it can be used as a data attribute for tracking
export const generateTrackingAttributes = (data: { [key: string]: string }) => {
  const trackingProps = {};
  for (const [key, value] of Object.entries(data)) {
    trackingProps[`data-${key}`] = value;
  }
  return trackingProps;
};

export const legacyTracking = (response: SubscriptionResponse) => {
  const {
    affiliation,
    email,
    initialSubscriptionPrice,
    offerCode,
    productSku,
    redirectTo,
    stripePlanName,
    subscriptionVariant,
    trackConversion,
    userId,
  } = response;
  if (trackConversion) {
    window.createAhoyEvent(email);
    analyticsIdentify(userId.toString(), { call_location: 'tracking.ts' });
    analyticsTrack(SUBSCRIPTION_CONVERSION_EVENT_NAME, {
      value: initialSubscriptionPrice,
    });

    const gtagObject = {
      affiliation: affiliation,
      currency: 'USD',
      items: [
        {
          brand: 'The Information', // TODO: Set enum: "The Information", "NEWSLETTER_NAME"
          category: 'Subscriptions', // TODO: Set enum: "Subscriptions" | "Newsletters" | "Events"
          coupon: offerCode,
          id: productSku, // Aligns with GA SKU
          name: stripePlanName, // Aligns with GA Product Name
          price: initialSubscriptionPrice,
          quantity: 1,
          variant: subscriptionVariant,
        },
      ],
      transaction_id: `${userId}_${Date.now()}`,
      value: parseInt(initialSubscriptionPrice),
    };
    gtag('event', GtagEvents.PURCHASE, gtagObject);
    triggerImpactSubscriptionConversion({
      email: email,
      initialSubscriptionPrice: initialSubscriptionPrice,
      newCustomer: false,
      offerCode: offerCode,
      productSku: productSku,
      stripePlanName: stripePlanName,
      userId: userId,
    });
  }

  window.location.href = redirectTo;
};

export const cleanQueryForClickText = (query: string): string => {
  // Replace newlines and carriage returns with spaces, and trim the string
  return query.replace(/\n|\r/g, ' ').trim();
};

export const triggerEventToAhoy = (event_name, properties = {}) => {
  window?.sendEventToAhoy(event_name, properties);
};
